<template>
  <div>
    <div class="card p-4 shadow-sm">
      <h3 class="mb-3">Platillos</h3>

      <!-- Buscador y filtro -->
      <div class="row mb-3">
        <div class="col-md-6">
          <input
            type="text"
            class="form-control"
            placeholder="Buscar platillo por nombre"
            v-model="busqueda"
            @input="buscarPlatillo"
          />
        </div>
        <div class="col-md-6">
          <select v-model.number="categoriaFiltro" class="form-select" @change="buscarPlatillo">
            <option :value="0">-- Todas las categorías --</option>
            <option v-for="cat in categorias" :key="cat.IdCategoria" :value="cat.IdCategoria">
              {{ cat.Categoria }}
            </option>
          </select>
        </div>
      </div>

      <!-- Botón agregar -->
      <div class="d-flex justify-content-end mb-3">
        <button class="btn btn-success" @click="mostrarFormulario = true">
          + Agregar Platillo
        </button>
      </div>

      <!-- Toast -->
      <div
        v-if="mostrarToast"
        class="toast-container position-fixed top-0 end-0 p-3"
        style="z-index: 1055"
      >
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- Formulario crear -->
      <div v-if="mostrarFormulario" class="mb-4">
        <h5 class="mb-3">Nuevo Platillo</h5>
        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label">Nombre</label>
            <input v-model="nuevoPlatillo.Nombre" type="text" class="form-control" />
          </div>
          <div class="col-md-2">
            <label class="form-label">Precio</label>
            <input v-model.number="nuevoPlatillo.Precio" type="number" min="0" step="0.01" class="form-control" />
          </div>
          <div class="col-md-2">
  <label class="form-label">Precio Costo</label>
  <input v-model.number="nuevoPlatillo.PrecioCosto" type="number" min="0" step="0.01" class="form-control" />
</div>

          <div class="col-md-3">
            <label class="form-label">Categoría</label>
            <select v-model.number="nuevoPlatillo.IdCategoria" class="form-select">
              <option disabled value="">-- Selecciona --</option>
              <option v-for="cat in categorias" :key="cat.IdCategoria" :value="cat.IdCategoria">
                {{ cat.Categoria }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
  <label class="form-label">Área de Producción</label>
  <select v-model.number="nuevoPlatillo.AreaProduccion" class="form-select">
    <option :value="1">Cocina</option>
    <option :value="2">Barra</option>
  </select>
</div>

          <div class="col-md-3">
            <label class="form-label">Descripción</label>
            <input v-model="nuevoPlatillo.Descripcion" type="text" class="form-control" />
          </div>
        </div>

        <!-- Receta -->
        <h6 class="mt-3">Receta Base</h6>
        <div v-for="(rec, index) in nuevoPlatillo.receta" :key="index" class="row g-3 mb-2">
          <div class="col-md-5">
            <SearchableSelect
              v-model="rec.IdProductoRestaurante"
              :items="productos"
              item-value="IdProductoRestaurante"
              item-label="NombreProducto"
              placeholder="Buscar producto..."
              :show-selected="false"
            />
          </div>
          <div class="col-md-3">
            <input v-model.number="rec.Cantidad" type="number" min="1" step="1" class="form-control" placeholder="Cantidad" />
          </div>
          <div class="col-md-1 d-flex align-items-end">
            <button class="btn btn-danger btn-sm" @click="eliminarReceta(index, 'nuevo')">X</button>
          </div>
        </div>
        <button class="btn btn-secondary btn-sm mt-2" @click="agregarReceta('nuevo')">+ Agregar Ingrediente</button>

        <!-- Grupos -->
        <h6 class="mt-3">Grupos de Opciones</h6>
        <div v-for="(grp, index) in nuevoPlatillo.grupos" :key="index" class="row g-3 mb-2">
          <div class="col-md-10">
            <SearchableSelect
              v-model="grp.IdGrupoOpcion"
              :items="grupos"
              item-value="IdGrupoOpcion"
              item-label="NombreGrupo"
              placeholder="Buscar grupo..."
              :show-selected="false"
            />
          </div>
          <div class="col-md-2 d-flex align-items-end">
            <button class="btn btn-danger btn-sm" @click="eliminarGrupo(index, 'nuevo')">X</button>
          </div>
        </div>
        <button class="btn btn-secondary btn-sm mt-2" @click="agregarGrupo('nuevo')">+ Agregar Grupo</button>

        <div class="text-end mt-3">
          <button class="btn btn-primary me-2" @click="guardarPlatillo">Guardar</button>
          <button class="btn btn-secondary" @click="cancelarFormulario">Cancelar</button>
        </div>
      </div>

      <!-- Tabla responsive-->
      <div class="table-responsive">
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Nombre</th>
              <th>Precio</th>
              <th>Precio Costo</th>
               <th>Área Producción</th>
              <th>Categoría</th>
              <th>Receta Base</th>
              <th>Grupos</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="platillos.length === 0">
              <td colspan="6">No hay platillos registrados.</td>
            </tr>
            <tr v-for="plt in platillos" :key="plt.IdPlatillo">
              <td>{{ plt.Nombre }}</td>
              <td>Q{{ Number(plt.Precio).toFixed(2) }}</td>
              <td>Q{{ Number(plt.PrecioCosto).toFixed(2) }}</td>
              <td>{{ plt.AreaProduccionNombre }}</td>
              <td>{{ plt.categoria?.Categoria }}</td>
              <td>
                <ul class="list-unstyled">
                  <li v-for="rec in plt.receta" :key="rec.IdRecetaPlatillo">
                    {{ rec.producto?.NombreProducto }} - Cant: {{ rec.Cantidad }}
                  </li>
                </ul>
              </td>
              <td>
                <ul class="list-unstyled">
                  <li v-for="g in plt.grupos" :key="g.IdGrupoOpcion">
                    {{ g.grupo?.NombreGrupo }}
                  </li>
                </ul>
              </td>
              <td>
                <button class="btn btn-primary btn-sm me-2" @click="abrirModal(plt)">Editar</button>
                <button class="btn btn-warning btn-sm me-2" @click="abrirModalDescontar(plt)">Descontar</button>
                <button class="btn btn-danger btn-sm" @click="abrirModalEliminar(plt)">Eliminar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal Editar -->
<div v-if="mostrarModalEditar" class="modal-backdrop">
  <div class="modal-content overflow-scroll max-h-[500px]">
    <h5>Editar Platillo</h5>
    <div class="row g-3 mt-3">
      <div class="col-md-5">
        <label class="form-label">Nombre</label>
        <input v-model="editarPlatillo.Nombre" type="text" class="form-control" />
      </div>

      <div class="col-md-2">
        <label class="form-label">Precio</label>
        <input v-model.number="editarPlatillo.Precio" type="number" min="0" step="0.01" class="form-control" />
      </div>

      <div class="col-md-3">
  <label class="form-label">Precio Costo</label>
  <input v-model.number="editarPlatillo.PrecioCosto" type="number" min="0" step="0.01" class="form-control" />
</div>

      <div class="col-md-4">
        <label class="form-label">Área de Producción</label>
        <select v-model.number="editarPlatillo.AreaProduccion" class="form-select">
          <option :value="1">Cocina</option>
          <option :value="2">Barra</option>
        </select>
      </div>

      <div class="col-md-6">
        <label class="form-label">Categoría</label>
        <select v-model.number="editarPlatillo.IdCategoria" class="form-select">
          <option disabled value="">-- Selecciona --</option>
          <option v-for="cat in categorias" :key="cat.IdCategoria" :value="cat.IdCategoria">
            {{ cat.Categoria }}
          </option>
        </select>
      </div>
    </div>



        <!-- Receta -->
        <h6 class="mt-3">Receta Base</h6>
        <div v-for="(rec, index) in editarPlatillo.receta" :key="index" class="row g-3 mb-2">
          <div class="col-md-5">
            <SearchableSelect
              v-model="rec.IdProductoRestaurante"
              :items="productos"
              item-value="IdProductoRestaurante"
              item-label="NombreProducto"
              placeholder="Buscar producto..."
              :show-selected="false"
            />
          </div>
          <div class="col-md-3">
            <input v-model.number="rec.Cantidad" type="number" min="1" step="1" class="form-control" placeholder="Cantidad" />
          </div>
          <div class="col-md-1 d-flex align-items-end">
            <button class="btn btn-danger btn-sm" @click="eliminarReceta(index, 'editar')">X</button>
          </div>
        </div>
        <button class="btn btn-secondary btn-sm mt-2" @click="agregarReceta('editar')">+ Agregar Ingrediente</button>

        <!-- Grupos -->
        <h6 class="mt-3">Grupos de Opciones</h6>
        <div v-for="(grp, index) in editarPlatillo.grupos" :key="index" class="row g-3 mb-2">
          <div class="col-md-10">
            <SearchableSelect
              v-model="grp.IdGrupoOpcion"
              :items="grupos"
              item-value="IdGrupoOpcion"
              item-label="NombreGrupo"
              placeholder="Buscar grupo..."
              :show-selected="false"
            />
          </div>
          <div class="col-md-2 d-flex align-items-end">
            <button class="btn btn-danger btn-sm" @click="eliminarGrupo(index, 'editar')">X</button>
          </div>
        </div>
        <button class="btn btn-secondary btn-sm mt-2" @click="agregarGrupo('editar')">+ Agregar Grupo</button>

        <div class="text-end mt-3">
          <button class="btn btn-secondary me-2" @click="cerrarModalEditar">Cancelar</button>
          <button class="btn btn-primary" @click="actualizarPlatillo">Guardar</button>
        </div>
      </div>
    </div>

    <!-- Modal Eliminar -->
    <div v-if="mostrarModalEliminar" class="modal-backdrop">
      <div class="modal-content">
        <h5>Confirmar eliminación</h5>
        <p>¿Seguro que deseas eliminar el platillo <strong>{{ platilloAEliminar?.Nombre }}</strong>?</p>
        <div class="text-end mt-3">
          <button class="btn btn-secondary me-2" @click="cerrarModalEliminar">Cancelar</button>
          <button class="btn btn-danger" @click="eliminarPlatillo">Eliminar</button>
        </div>
      </div>
    </div>

    <!-- Modal Descontar -->
    <div v-if="mostrarModalDescontar" class="modal-backdrop">
      <div class="modal-content">
        <h5>Confirmar Descuento de Platillo</h5>
        <p>¿Seguro que deseas descontar el platillo <strong>{{ platilloADescontar?.Nombre }}</strong> del inventario de <strong>{{ platilloADescontar?.AreaProduccionNombre }}</strong>?</p>

        <div class="alert alert-info mt-3">
          <strong>Se descontarán los siguientes ingredientes:</strong>
          <ul class="mt-2">
            <li v-for="rec in platilloADescontar?.receta" :key="rec.IdRecetaPlatillo">
              {{ rec.producto?.NombreProducto }} - Cantidad: {{ rec.Cantidad }}
            </li>
          </ul>
        </div>

        <div v-if="descontandoPlatillo" class="text-center my-3">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Descontando...</span>
          </div>
          <p class="mt-2">Descontando inventario...</p>
        </div>

        <div class="text-end mt-3">
          <button class="btn btn-secondary me-2" @click="cerrarModalDescontar" :disabled="descontandoPlatillo">Cancelar</button>
          <button class="btn btn-warning" @click="descontarPlatillo" :disabled="descontandoPlatillo">Confirmar Descuento</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";
import SearchableSelect from "@/components/shared/SearchableSelect.vue";

export default {
  components: {
    SearchableSelect
  },
  name: "PlatillosRestaurante",
  data() {
    return {
      platillos: [],
      productos: [],
      categorias: [],
      grupos: [],
      copiaLista: [],
      busqueda: "",
      categoriaFiltro: 0,
      mostrarFormulario: false,
      nuevoPlatillo: {
        Nombre: "",
        Precio: 0,
        PrecioCosto:0,
        Descripcion: "",
        IdCategoria: "",
        AreaProduccion: 1,
        receta: [{ IdProductoRestaurante: "", Cantidad: 1 }],
        grupos: [{ IdGrupoOpcion: "" }]
      },
      editarPlatillo: null,
      mostrarModalEditar: false,
      mostrarModalEliminar: false,
      platilloAEliminar: null,
      mostrarModalDescontar: false,
      platilloADescontar: null,
      descontandoPlatillo: false,
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" }
    };
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    }
  },
  watch: {
    // Cuando se selecciona categoría Bebidas (4), poner automáticamente AreaProduccion=2 (Barra)
    'nuevoPlatillo.IdCategoria'(nuevoValor) {
      if (nuevoValor === 4) {
        this.nuevoPlatillo.AreaProduccion = 2;
      }
    },
    'editarPlatillo.IdCategoria'(nuevoValor) {
      if (this.editarPlatillo && nuevoValor === 4) {
        this.editarPlatillo.AreaProduccion = 2;
      }
    }
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerPlatillos() {
      const { data } = await axios.get(`${API_URL}/platillos`);
      this.platillos = data.data || data;
      this.copiaLista = [...this.platillos];
    },
    async obtenerProductos() {
      const { data } = await axios.get(`${API_URL}/inventario-general-restaurante`);
      this.productos = data;
    },
    async obtenerCategorias() {
      const { data } = await axios.get(`${API_URL}/categorias-comida`);
      this.categorias = data;
    },
    async obtenerGrupos() {
      const { data } = await axios.get(`${API_URL}/grupos-opciones`);
      this.grupos = data.data || data;
    },
    // Métodos reutilizables para nuevo/editar
    agregarReceta(contexto = 'nuevo') {
      const recetaBase = { IdProductoRestaurante: "", Cantidad: 1 };
      if (contexto === 'nuevo') this.nuevoPlatillo.receta.push(recetaBase);
      else if (contexto === 'editar') this.editarPlatillo.receta.push(recetaBase);
    },
    eliminarReceta(index, contexto = 'nuevo') {
      if (contexto === 'nuevo') this.nuevoPlatillo.receta.splice(index, 1);
      else if (contexto === 'editar') this.editarPlatillo.receta.splice(index, 1);
    },
    agregarGrupo(contexto = 'nuevo') {
      const grupoBase = { IdGrupoOpcion: "" };
      if (contexto === 'nuevo') this.nuevoPlatillo.grupos.push(grupoBase);
      else if (contexto === 'editar') this.editarPlatillo.grupos.push(grupoBase);
    },
    eliminarGrupo(index, contexto = 'nuevo') {
      if (contexto === 'nuevo') this.nuevoPlatillo.grupos.splice(index, 1);
      else if (contexto === 'editar') this.editarPlatillo.grupos.splice(index, 1);
    },
    async guardarPlatillo() {
      try {
        const { data } = await axios.post(`${API_URL}/platillos`, this.nuevoPlatillo);
        this.mostrarAlerta(data.message || "Platillo creado con éxito");
        this.nuevoPlatillo = {
          Nombre: "",
          Precio: 0,
          Descripcion: "",
          IdCategoria: "",
          receta: [{ IdProductoRestaurante: "", Cantidad: 1 }],
          grupos: [{ IdGrupoOpcion: "" }]
        };
        this.mostrarFormulario = false;
        this.obtenerPlatillos();
      } catch (error) {
        this.mostrarAlerta(error.response?.data?.message || "Error al guardar", "danger");
      }
    },
    abrirModal(platillo) {
      this.editarPlatillo = JSON.parse(JSON.stringify(platillo));
      this.mostrarModalEditar = true;
    },
    cerrarModalEditar() {
      this.editarPlatillo = null;
      this.mostrarModalEditar = false;
    },
    async actualizarPlatillo() {
      try {
        const { data } = await axios.put(
          `${API_URL}/platillos/${this.editarPlatillo.IdPlatillo}`,
          this.editarPlatillo
        );
        this.mostrarAlerta(data.message || "Platillo actualizado con éxito");
        this.cerrarModalEditar();
        this.obtenerPlatillos();
      } catch (error) {
        this.mostrarAlerta(error.response?.data?.message || "Error al actualizar", "danger");
      }
    },
    abrirModalEliminar(platillo) {
      this.platilloAEliminar = platillo;
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.platilloAEliminar = null;
      this.mostrarModalEliminar = false;
    },
    async eliminarPlatillo() {
      try {
        const { data } = await axios.delete(`${API_URL}/platillos/${this.platilloAEliminar.IdPlatillo}`);
        this.mostrarAlerta(data.message || "Platillo eliminado con éxito");
        this.obtenerPlatillos();
      } catch (error) {
        this.mostrarAlerta(error.response?.data?.message || "Error al eliminar", "danger");
      } finally {
        this.cerrarModalEliminar();
      }
    },
    buscarPlatillo() {
      const q = (this.busqueda || "").trim().toLowerCase();
      this.platillos = this.copiaLista.filter(plt => {
        const coincideNombre = (plt.Nombre || "").toLowerCase().includes(q);
        const coincideCategoria = this.categoriaFiltro === 0 || plt.IdCategoria === this.categoriaFiltro;
        return coincideNombre && coincideCategoria;
      });
    },
    cancelarFormulario() {
      this.mostrarFormulario = false;
      this.nuevoPlatillo = {
        Nombre: "",
        Precio: 0,
        Descripcion: "",
        IdCategoria: "",
        receta: [{ IdProductoRestaurante: "", Cantidad: 1 }],
        grupos: [{ IdGrupoOpcion: "" }]
      };
    },
    abrirModalDescontar(platillo) {
      this.platilloADescontar = platillo;
      this.mostrarModalDescontar = true;
    },
    cerrarModalDescontar() {
      this.platilloADescontar = null;
      this.mostrarModalDescontar = false;
      this.descontandoPlatillo = false;
    },
    async descontarPlatillo() {
      this.descontandoPlatillo = true;
      try {
        const { data } = await axios.post(
          `${API_URL}/platillos/${this.platilloADescontar.IdPlatillo}/descontar`
        );
        this.mostrarAlerta(data.message || "Platillo descontado exitosamente", "success");
        this.cerrarModalDescontar();

        // Mostrar detalles adicionales si hay errores o advertencias
        if (data.errores && data.errores.length > 0) {
          console.warn("Advertencias durante el descuento:", data.errores);
        }
      } catch (error) {
        const mensaje = error.response?.data?.message || "Error al descontar el platillo";
        const errores = error.response?.data?.errores || [];

        let mensajeCompleto = mensaje;
        if (errores.length > 0) {
          mensajeCompleto += ": " + errores.join(", ");
        }

        this.mostrarAlerta(mensajeCompleto, "danger");
        this.descontandoPlatillo = false;
      }
    }
  },
  mounted() {
    this.obtenerPlatillos();
    this.obtenerProductos();
    this.obtenerCategorias();
    this.obtenerGrupos();
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5000;
}
.modal-content {
  background: #fff;
  width: 600px;
  max-height: 500px !important;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  z-index: 5001;
}
</style>
